import { motion } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import SEO from "@/components/SEO";
import BackgroundGradient from "@/components/landing/BackgroundGradient";

const NotFound = () => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    console.error("404:", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <SEO title="404 — Page Not Found — Dyna Agency" description="This page doesn't exist." noindex />
      <BackgroundGradient />
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "0 var(--site-px)", position: "relative", zIndex: 1 }}>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        style={{ textAlign: "center", maxWidth: 560, position: "relative" }}
      >
        <div style={{
          fontFamily: "Coolvetica, system-ui, sans-serif",
          fontSize: "clamp(96px, 20vw, 180px)",
          fontWeight: 700,
          letterSpacing: "0.05em",
          lineHeight: 1,
          color: "var(--nova-600)",
          textShadow: "var(--glow-nova)",
          marginBottom: 24,
        }}>
          404
        </div>

        <h1 style={{
          fontFamily: "Coolvetica, system-ui, sans-serif",
          fontSize: 40, fontWeight: 700,
          letterSpacing: "0.04em", textTransform: "uppercase",
          color: "var(--dyna-fg)", margin: "0 0 16px",
        }}>
          {t("pages.notFound.title")}
        </h1>

        <p style={{ fontFamily: "Geist, system-ui, sans-serif", fontSize: 17, lineHeight: 1.7, color: "var(--dyna-fg-muted)", margin: "0 0 40px" }}>
          {t("pages.notFound.body")}
        </p>

        <Link
          to="/"
          className="dyna-btn dyna-btn--primary"
        >
          {t("pages.notFound.backHome")}
        </Link>
      </motion.div>
      </div>
    </>
  );
};

export default NotFound;
